const currencies = [
  "ARS",
  "AUD",
  "BRL",
  "CAD",
  "CHF",
  "CLP",
  "CNY",
  "COP",
  "CZK",
  "DKK",
  "EEK",
  "EUR",
  "GBP",
  "GTQ",
  "HKD",
  "HUF",
  "INR",
  "ISK",
  "JPY",
  "KRW",
  "LTL",
  "LVL",
  "MXN",
  "MYR",
  "NLG",
  "NOK",
  "NZD",
  "PLN",
  "RON",
  "RUB",
  "SEK",
  "SGD",
  "SKK",
  "THB",
  "TRY",
  "TWD",
  "USD",
  "VND",
];

export default currencies;
